import { useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import PlaceIcon from '@mui/icons-material/Place'
import SettingsIcon from '@mui/icons-material/Settings'
import StorageIcon from '@mui/icons-material/Storage'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import { makeStyles } from '@mui/styles'

import { Role } from 'utils/constant'

const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    '&[data-mode="drawer"]': {
      background: '#fff',
    },
    '&[data-mode="sidebar"]': {
      background: '#222',
    },
  },
  item: {
    paddingRight: spacing(4),
  },
  icon: {
    padding: spacing(2, 0),
    minWidth: 40,
    '&[data-mode="sidebar"]': {
      '&[data-active="true"]': {
        color: palette.primary.light,
      },
      '&[data-active="false"]': {
        color: '#ccc',
      },
    },
    '&[data-mode="drawer"]': {
      '&[data-active="true"]': {
        color: palette.primary.main,
      },
      '&[data-active="false"]': {
        color: '#888',
      },
    },
  },
  text: {
    '&[data-mode="sidebar"]': {
      '&[data-active="true"]': {
        color: palette.primary.light,
        fontWeight: 'bold',
      },
      '&[data-active="false"]': {
        color: '#ccc',
        fontWeight: 'normal',
      },
    },
    '&[data-mode="drawer"]': {
      '&[data-active="true"]': {
        color: palette.primary.main,
        fontWeight: 'bold',
      },
      '&[data-active="false"]': {
        color: '#888',
        fontWeight: 'normal',
      },
    },
  },
}))

export default function AccountMenu({ account, onClick, drawer = false }) {
  const { push } = useHistory()
  const { pathname } = useLocation()
  const classes = useStyles()
  const mode = drawer ? 'drawer' : 'sidebar'

  const menu = useMemo(() => {
    if (account.role === Role.LOCATION_MEMBER.value) {
      return [
        { path: 'stocks', label: '在庫管理', icon: StorageIcon },
        { path: 'members', label: 'メンバー管理', icon: AccountCircleIcon },
        { path: 'settings', label: '各種設定', icon: SettingsIcon },
      ]
    } else {
      return [
        { path: 'stocks', label: '在庫管理', icon: StorageIcon },
        { path: 'members', label: 'メンバー管理', icon: AccountCircleIcon },
        { path: 'locations', label: '拠点管理', icon: PlaceIcon },
        { path: 'settings', label: '各種設定', icon: SettingsIcon },
      ]
    }
  }, [account])

  const handleClick = path => {
    push(path)
    if (onClick) {
      onClick()
    }
  }

  return (
    <List className={classes.root} data-mode={mode}>
      {menu.map(x => {
        const path = `/accounts/${account.id}/${x.path}`
        const active = pathname.startsWith(path)
        return (
          <ListItem
            key={x.path}
            button
            className={classes.item}
            onClick={() => handleClick(x.path)}
          >
            <ListItemIcon className={classes.icon} data-mode={mode} data-active={active}>
              <x.icon />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography className={classes.text} data-mode={mode} data-active={active}>
                  {x.label}
                </Typography>
              }
            />
          </ListItem>
        )
      })}
    </List>
  )
}
